import dark from './dark';
import light from './light';
import secondary from './secondary';
import primary from './primary';

export default {
  dark,
  light,
  primary,
  secondary,
};
